export const ADDTOCART_DETAILS_GET_REQUEST = 'ADDTOCART_DETAILS_GET_REQUEST';
export const ADDTOCART_DETAILS_GET_ERROR = 'ADDTOCART_DETAILS_GET_ERROR';
export const ADDTOCART_DETAILS_GET_SUCCESS = 'ADDTOCART_DETAILS_GET_SUCCESS';
export const CARE_PLAN_WARRANTY_REQUEST = 'CARE_PLAN_WARRANTY_REQUEST';
export const CARE_PLAN_WARRANTY_RESPONSE = 'CARE_PLAN_WARRANTY_RESPONSE';
export const CARE_PLAN_WARRANTY_SET_API_STATUS = 'CARE_PLAN_WARRANTY_SET_API_STATUS';
export const ADDTOCART_DETAILS_RESET = 'ADDTOCART_DETAILS_RESET';
export const SET_INTERSTITIAL_SKU_ID = 'SET_INTERSTITIAL_SKU_ID';
export const SET_INTERSTITIAL_ITEM = 'SET_INTERSTITIAL_ITEM';
